import { StreakMapCell, StreakMapDay } from './types'

export const calcCounDaysRead = (streaks: StreakMapDay[]) => {
  return streaks.filter((streak) => streak.value).length || 0
}

export const transformStreaks = (streaks: StreakMapDay[]): StreakMapCell[] => {
  const getType = (day: StreakMapDay) => {
    if (day.is_best_streak) return 'best-streak'
    if (day.is_finished) return 'finished'
    if (day.value) return 'days-read'
    return 'none'
  }

  return streaks.map((day) => ({
    day: day.date,
    type: getType(day),
  }))
}
